// extracted by mini-css-extract-plugin
module.exports = {"modernScrollbar":"Timeline2_modernScrollbar__RcEuW","customScrollbar":"Timeline2_customScrollbar__pDr_F"};